<div class="advanced-settings">
  <div class="content">

    <div class="content__title">Checkout History</div>
    <div class="content__box" style="max-height: 35rem; overflow-y: scroll;">
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Product</th>
              <th>Date</th>
              <th>Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let checkout of checkouts.data">
              <td>{{ checkout.productName ?? 'N/A' }}</td>
              <td>{{ checkout.createdAt | date : "short" }}</td>
              <td>
                {{ checkout.totalAmount | currency }}
              </td>
              <td>
                <span class="badge"
                  [ngClass]="{'badge-success': checkout.status === 'completed', 'badge-danger': checkout.status === 'failed'}">
                  {{ checkout.status }}
                </span>
              </td>
            </tr>
            <tr *ngIf="checkouts.data.length === 0">
              <td colspan="4" class="text-center">No Checkouts.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <nav *ngIf="checkouts.pagination.totalPages > 1" aria-label="Checkout pagination" class="mt-3">
        <ul class="pagination justify-content-center mb-0">
          <li class="page-item" [class.disabled]="checkouts.pagination.currentPage === 1">
            <button class="page-link" (click)="initData(1)"
              [disabled]="checkouts.pagination.currentPage === 1">&laquo;</button>
          </li>
          <li class="page-item" *ngFor="let p of [].constructor(checkouts.pagination.totalPages); let i = index"
            [class.active]="checkouts.pagination.currentPage === i + 1">
            <button class="page-link" (click)="initData(i + 1)">{{ i + 1 }}</button>
          </li>
          <li class="page-item" [class.disabled]="checkouts.pagination.currentPage === checkouts.pagination.totalPages">
            <button class="page-link" (click)="initData(checkouts.pagination.currentPage + 1)"
              [disabled]="checkouts.pagination.currentPage === checkouts.pagination.totalPages">&raquo;</button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>